import apiConfig from '../../../../../../../config/api'
import { apiRequestorHelper } from '../../../../../../../helpers'

export const getCdiDeclarationSumaryService = ({dateValue}) => {
    return apiRequestorHelper({
        url: apiConfig.url + '/transaction/inside/getCdiDeclarationSumary',
        method: 'post',
        body: {
            dateRange: dateValue
        }
    })
}
